import { FilterResult } from '../../components/odata-filter/models/filter-result';
import { IEvaluationAggregateQueryModel } from './evaluationAggregateQueryModel';

export class EvaluationAggregateFilterResult implements FilterResult {
  public count: number;
  public values: IEvaluationAggregateQueryModel[] = [];
  public nextLink: string;

  public parse(response: any) {
    let result = new EvaluationAggregateFilterResult();
    result.count = response['@odata.count'];
    result.values = response.value[0].evaluationAggregates;
    result.nextLink = response['@odata.nextLink'];
    return result;
  }
}
